import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { IoAddCircleOutline, IoCalendarSharp } from "react-icons/io5";
import classes from './Sidebar.module.css';
import { FaGear } from 'react-icons/fa6';
// import SidebarMenu from './SidebarMenu';
import { useDispatch, useSelector } from 'react-redux';
// import { sideBarActions } from '../../store/sidebar';
import { FaHome, FaFileSignature, FaThList, FaWhatsapp, FaProjectDiagram, FaFolder } from "react-icons/fa";
import * as fa from 'react-icons/fa';
import { config } from '../../config';
import { getAuthToken } from '../../util/auth';
import { TfiEmail } from 'react-icons/tfi';

const Sidebar = () => {
    const pathname = useLocation().pathname;
    const dispatch = useDispatch();
    // const sidebarMenuItemsList = useSelector(state => state.sidebar.menuItemsList);

    const handleSidebarMenuShow = () => {
        // dispatch(sideBarActions.showSideModal());
    }

    return (
        <div className={classes.sidebar}>
            <ul className={classes.menuList}>
                <li className={pathname === '/sys' ? 'active' : ''}>
                    <Link to="/sys">
                        <div style={{ fontSize: '22px' }}><FaHome /></div>
                        <div style={{ textAlign: 'center', fontSize: '14px' }}>Dashboard</div>
                    </Link>
                </li>
                <li className={pathname === '/sys/lists' ? 'active' : ''}>
                    <Link to="/sys/lists">
                        <div style={{ fontSize: '22px' }}><FaThList /></div>
                        <div style={{ textAlign: 'center', fontSize: '14px' }}>Lists</div>
                    </Link>
                </li>
                <li className={pathname === '/sys/mailbox' || pathname.startsWith('/sys/mailbox/', 0) ? 'active' : ''}>
                    <Link to="/sys/mailbox">
                        <div style={{ fontSize: '22px' }}><TfiEmail /></div>
                        <div style={{ textAlign: 'center', fontSize: '14px' }}>Mailbox</div>
                    </Link>
                </li>
                <li className={pathname === '/sys/forms' || pathname.startsWith('/sys/forms/', 0) ? 'active' : ''}>
                    <Link to="/sys/forms">
                        <div style={{ fontSize: '22px' }}><FaFileSignature /></div>
                        <div style={{ textAlign: 'center', fontSize: '14px' }}>Forms</div>
                    </Link>
                </li>
                <li className={pathname === '/sys/settings' || pathname.startsWith('/sys/settings/', 0) ? 'active' : ''}>
                    <Link to="/sys/settings">
                        <div style={{ fontSize: '22px' }}><FaGear /></div>
                        <div style={{ textAlign: 'center', fontSize: '14px' }}>Settings</div>
                    </Link>
                </li>
                {/* <li className={pathname === '/sys/digsign' ? 'active' : ''}>
                    <Link to="/sys/digsign">
                        <div style={{ fontSize: '22px' }}><FaFileSignature /></div>
                        <div style={{ textAlign: 'center', fontSize: '14px' }}>חתימה דיגיתאלית</div>
                    </Link>
                </li> */}
                {/* <li className={pathname === '/sys/whatsapp' ? 'active' : ''}>
                    <Link to="/sys/whatsapp">
                        <div style={{ fontSize: '22px' }}><FaWhatsapp /></div>
                        <div style={{ textAlign: 'center', fontSize: '14px' }}>Whatsapp</div>
                    </Link>
                </li> */}
                {/* <li className={pathname === '/sys/calendar' ? 'active' : ''}>
                    <Link to="/sys/calendar">
                        <div style={{ fontSize: '22px' }}><IoCalendarSharp /></div>
                        <div style={{ textAlign: 'center', fontSize: '14px' }}>יומנים</div>
                    </Link>
                </li> */}
                {/* <li className={pathname === '/sys/automations' ? 'active' : ''}>
                    <Link to="/sys/automations">
                        <div style={{ fontSize: '22px' }}><FaProjectDiagram /></div>
                        <div style={{ textAlign: 'center', fontSize: '14px' }}>אוטומציה</div>
                    </Link>
                </li> */}
                {/* <li className={pathname === '/sys/clientsFolders' || pathname.startsWith('/sys/clientsFolders/', 0) ? 'active' : ''}>
                    <Link to="/sys/clientsFolders">
                        <div style={{ fontSize: '22px' }}><FaFolder /></div>
                        <div style={{ textAlign: 'center', fontSize: '14px' }}>תיקי לקוחות</div>
                    </Link>
                </li> */}

                {/* {sidebarMenuItemsList && sidebarMenuItemsList.map((menuItem, index) => {
                    const Icon = fa[menuItem.icon];

                    if (menuItem.openIn === 'iframe') {
                        return (
                            <li key={index}>
                                <Link to={'/sys/external'} onClick={(e) => { dispatch(sideBarActions.updateIframeSrc(menuItem.path)); }} >
                                    <div style={{ fontSize: '22px' }}><Icon /></div>
                                    <div style={{ textAlign: 'center', fontSize: '14px' }}>{menuItem.title}</div>
                                </Link>
                            </li>
                        );
                    }

                    return (
                        <li key={index}>
                            <Link
                                to={menuItem.path}
                                rel="noreferrer"
                                target={menuItem.openIn === 'sameTab' ? '_self' : '_blank'}
                            >
                                <div style={{ fontSize: '22px' }}><Icon /></div>
                                <div style={{ textAlign: 'center', fontSize: '14px' }}>{menuItem.title}</div>
                            </Link>
                        </li>
                    );
                })}

                {sidebarMenuItemsList.length > 0 && <hr style={{ color: '#ecc383', opacity: '0.5' }} />} */}

                <li>
                    <Link to="#" onClick={handleSidebarMenuShow}>
                        <div style={{ fontSize: '28px', lineHeight: '20px' }}><IoAddCircleOutline /></div>
                    </Link>
                </li>
            </ul>

            {/* <SidebarMenu /> */}
        </div>
    );
};

export default Sidebar;
